import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { adminFetch, clearAdminToken, isAdmin, setAdminToken } from '../utils/admin';

function AdminLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [loggedIn, setLoggedIn] = useState(isAdmin());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await adminFetch('/admin/verify', { method: 'POST' }, password);
      setAdminToken(password);
      setLoggedIn(true);
      // Only follow same-site relative paths
      navigate(next && next.startsWith('/') && !next.startsWith('//') ? next : '/');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleLogout = () => {
    clearAdminToken();
    setLoggedIn(false);
  };

  return (
    <div className="section">
      <div className="box" style={{ maxWidth: '420px', margin: '0 auto' }}>
        <h2 className="title is-3">Admin</h2>
        {loggedIn ? (
          <>
            <p className="mb-4">
              You're logged in as an editor. Open a stratagem and use the "Edit chunks" button to adjust its chunks.
            </p>
            <div className="buttons">
              <button className="button is-link" onClick={() => navigate('/')}>Browse stratagems</button>
              <button className="button" onClick={handleLogout}>Log out</button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="label" htmlFor="admin-password">Admin password</label>
              <div className="control">
                <input
                  id="admin-password"
                  className="input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoFocus
                  required
                />
              </div>
            </div>
            {error && <p className="help is-danger mb-3">{error}</p>}
            <button className={`button is-primary ${submitting ? 'is-loading' : ''}`} type="submit" disabled={submitting}>
              Log in
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;
